export const _alertsFr = {
    newGameRequiermentsForName:
        `<div class='alert alert-danger'>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
        <h6 class='alert-heading'>
            Le nom de la partie doit être:
        </h6>
        <div>
            <li>Composer de 4 à 25 caractères.</li>
            <li>Pas de caractères spéciaux.</li>
        </div>
    </div>`,
    newGameCreatedSuccess:
        `<div class='alert alert-success'>
        <h6 class='alert-heading'>
            Partie créée avec succès
        </h6>
        <div class="text-center">
            Chargement ...
        </div>
    </div>`,
};

export const _alertsEn = {
    newGameRequiermentsForName:
        `<div class='alert alert-danger'>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
        <h6 class='alert-heading'>
        The name of the game should be:
        </h6>
        <div>
            <li>Compose 4 to 25 characters.</li>
            <li>No special characters.</li>
        </div>
    </div>`,
    newGameCreatedSuccess:
        `<div class='alert alert-success'>
        <h6 class='alert-heading'>
            Game created successfully
        </h6>
        <div class="text-center">
            Loading ...
        </div>
    </div>`,
};

export const _alertsDe = {
    newGameRequiermentsForName:
        `<div class='alert alert-danger'>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
        <h6 class='alert-heading'>
            Der Name des Spiels sollte sein:
        </h6>
        <div>
            <li>Bestehen Sie aus 4 bis 25 Zeichen.</li>
            <li>Keine Sonderzeichen.</li>
        </div>
    </div>`,
    newGameCreatedSuccess:
        `<div class='alert alert-success'>
        <h6 class='alert-heading'>
            Spiel erfolgreich erstellt
        </h6>
        <div class="text-center">
            Laden ...
        </div>
    </div>`,
};
